<div class="date-range-picker">
  <mat-calendar
    (selectedChange)="selectedChange($event)"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [selected]="dateRange"
    [startAt]="firstMonth"
  ></mat-calendar>
</div>
